import { useState, useEffect } from 'react'
import { generarVencimientos } from './data/fechas2026'
import BuscadorNIT from './components/BuscadorNIT'
import SemaforoTabla from './components/SemaforoTabla'
import DashboardTributario from './components/DashboardTributario'
import AsistenteIA from './components/AsistenteIA'
import styles from './CalendarioTributario.module.css'

const MESES = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]

// Registro del Service Worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        const esServidor =
            location.hostname !== 'localhost' &&
            !location.hostname.includes('127.0.0.1') &&
            location.protocol === 'https:'
        if (!esServidor) return
        try {
            await navigator.serviceWorker.register('/sw-tributario.js')
        } catch {}
    })
}

export default function CalendarioTributario() {
    const [tab, setTab]     = useState('semaforo')
    const [datos, setDatos] = useState([])
    const [nit, setNit]     = useState('')
    const [buscado, setBuscado] = useState(false)

    const hoy = new Date()
    const fechaHoy = `${hoy.getDate()} de ${MESES[hoy.getMonth()]} de ${hoy.getFullYear()}`

    function handleBuscar(nitVal, regimen, municipio) {
        const resultado = generarVencimientos(nitVal, regimen, municipio)
        setDatos(resultado)
        setNit(nitVal)
        setBuscado(true)
    }

    return (
        <div className={styles.page}>
            {/* HERO */}
            <div className={styles.hero}>
                <h1 className={styles.heroTitle}>🚦 Semáforo Tributario Colombia 2026</h1>
                <p className={styles.heroSub}>
                    Ingresa el NIT de tu empresa y consulta todos los vencimientos tributarios DIAN, Mi Planilla y Secretaría de Hacienda Bogotá
                </p>
                <div className={styles.fechaHoy}>📅 {fechaHoy}</div>
            </div>

            {/* BUSCADOR */}
            <BuscadorNIT onBuscar={handleBuscar} />

            {/* TABS */}
            <div className={styles.tabsNav}>
                <button
                    className={`${styles.tabBtn} ${tab === 'semaforo' ? styles.tabBtnActive : ''}`}
                    onClick={() => setTab('semaforo')}
                >
                    🚦 Semáforo
                </button>
                <button
                    className={`${styles.tabBtn} ${tab === 'dashboard' ? styles.tabBtnActive : ''}`}
                    onClick={() => setTab('dashboard')}
                >
                    📊 Dashboard
                </button>
            </div>

            {/* TAB SEMÁFORO */}
            {tab === 'semaforo' && (
                <>
                    {buscado ? (
                        <SemaforoTabla datos={datos} />
                    ) : (
                        <div className={styles.estadoInicial}>
                            <div className={styles.estadoInicialIcon}>🔍</div>
                            <h2 className={styles.estadoInicialH2}>Consulta el calendario tributario de tu empresa</h2>
                            <p className={styles.estadoInicialP}>
                                Ingresa el NIT arriba y selecciona el régimen de IVA para ver todos los vencimientos del año 2026 con colores automáticos
                            </p>
                        </div>
                    )}
                </>
            )}

            {/* TAB DASHBOARD */}
            {tab === 'dashboard' && (
                <DashboardTributario datos={datos} nit={nit} />
            )}

            {/* ASISTENTE IA */}
            <AsistenteIA datos={datos} nit={nit} />
        </div>
    )
}
